var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/AddressConstants.js');
var ActionTypes = Constants.ActionTypes;

module.exports = {
    receivedValidationResult: function (id, result, type, model, value, index, addressType) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVED_VALIDATION_RESULT,
            id: id,
            result: result,
            type: type,
            model: model,
            value: value,
            index: index, 
            addressType: addressType
        });
    },
    receivedOptions: function (id, options, type){
        AppDispatcher.dispatch({
            actionType: ActionTypes.RECEIVED_OPTIONS,
            id: id,
            options: options,
            type: type
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/AddressApiCallBackActions.js